import type { GridSnapLiveRect } from '@/lib/guides/grid-snap'

export const EMPTY_GRID_SNAP_RECTS: GridSnapLiveRect[] = []

export const CLICK_PREVENTION_DELAY_MS = 150

/** Ignore sub-pixel noise from rigid-translation detection (avoids setState feedback with many shapes). */
export const MULTI_SELECT_RIGID_TRANSLATION_MIN_PX = 1e-4
